import { render, staticRenderFns } from "./RiasecResultsCharts.vue?vue&type=template&id=0b139832&scoped=true&"
import script from "./RiasecResultsCharts.vue?vue&type=script&lang=js&"
export * from "./RiasecResultsCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b139832",
  null
  
)

export default component.exports